import * as React from 'react'
import { useMutation } from 'react-query'
import postEnrollCard from '@/src/card-linking/queries/PostEnrollCard'

const usePostEnrollCard = () => {
    return useMutation('postEnrollCard', postEnrollCard, {
        // @ts-ignore
        refetchOnWindowFocus: false,
    })
}

export default usePostEnrollCard
